import { createSlice } from "@reduxjs/toolkit";

const carritoSlice = createSlice({
  name: "carrito",
  initialState: {
    carrito: null,
    statusCode: 0,
    message: null,
    loading: false,
    error: null,
  },
  reducers: {
    setCarrito(state, action) {
      state.carrito = action.payload.data.carrito;
      state.statusCode = action.payload.code;
      state.message = action.payload.message;
      state.loading = false;
      state.error = null;
    },

    setLoading(state, action) {
      state.loading = action.payload;
    },

    setError(state, action) {
      state.error = action.payload;
      state.loading = false;
    },

    clearCarrito(state) {
      state.carrito = null;
      state.statusCode = 0;
      state.message = null;
      state.loading = false;
      state.error = null;
    }
  },
});

export const { 
  setCarrito, 
  setLoading,
  setError,
  clearCarrito 
} = carritoSlice.actions;

export default carritoSlice.reducer;